module.exports = __webpack_public_path__ + "static/media/net.b9684e07.svg";